import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './IPOSynopsis.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";

import IpoDetailsNew from "../../../Components/IPO/IpoDetailsNew/IpoDetailsNew"

function IPOSynopsis(props) {
    const [data, setData] = useState([]);
    const [Datatwo, setDatatwo] = useState([]);
    const [Datathree, setDatathree] = useState([]);
    const [Datafour, setDatafour] = useState([]);
    const [Datafive, setDatafive] = useState([]);
    const [Datasix, setDatasix] = useState([]);
    const [co_code, setco_code] = useState([]);
    const { getCompName, getcocode } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDatatwo, getDataGroup, getUrl, getDatathree, getDatafour, getDatafive, getDatasix;
    let PageSize = 8;


    useEffect(() => {
        if (getcocode != "") {
            const getUrl = BaseURL + "Iposynopsis";
            console.log("getUrl==============" + `${getUrl}/1/${getcocode}`)
            fetch(`${getUrl}/1/${getcocode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/2/${getcocode}`)
                .then((response) => response.json())
                .then((datatwo) => {
                    getDatatwo = datatwo.data;
                    setDatatwo(getDatatwo);
                    // console.log(getDatatwo, "getDatatwo")
                })
                .catch((error) => {
                });


            fetch(`${getUrl}/3/${getcocode}`)
                .then((response) => response.json())
                .then((datathree) => {
                    getDatathree = datathree.data;
                    setDatathree(getDatathree);
                    // console.log(getDatathree, "getDatathree")
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/4/${getcocode}`)
                .then((response) => response.json())
                .then((datafour) => {
                    getDatafour = datafour.data;
                    setDatafour(getDatafour);
                    // console.log(getDatafour, "getDatafour")
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/5/${getcocode}`)
                .then((response) => response.json())
                .then((datafive) => {
                    getDatafive = datafive.data;
                    setDatafive(getDatafive);
                    // console.log(getDatafive, "getDatafive")
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/6/${getcocode}`)
                .then((response) => response.json())
                .then((datasix) => {
                    getDatasix = datasix.data;
                    setDatasix(getDatasix);
                    // console.log(getDatasix, "getDatasix")
                })
                .catch((error) => {
                });

            const getUrlGroup = BaseURL + "GroupMaster";
            fetch(`${getUrlGroup}`)
                .then((response) => response.json())
                .then((dataG) => {
                    getDataGroup = dataG.data;
                    setDataGroup(getDataGroup);
                    //console.log(getDataGroup, "getDataGroup")
                })
                .catch((error) => {
                });
        }
    }, [getcocode]);

    // useEffect(() => {
    //     if (getCompName != "") {
    //         const getUrlchart = BaseURL + "getCo_Code";
    //         fetch(`${getUrlchart}/${getCompName}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 setco_code(data.data[0]["co_code"]);
    //                 //console.log(data)
    //             })
    //             .catch((error) => {
    //                 //console.log("not found the api");
    //             });
    //         }
    //     }, [])


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
        <IpoDetailsNew/>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='snop-loser-sc'>
                            <div className='snop-header'>
                                <h2><span>IPO Synopsis</span></h2>
                            </div>
                            <div className='snop-table'>
                                {currentTableData && currentTableData.map(
                                    ({ LEADMGR, lname, regadd1, regadd2, regdist, regpin, regstate, tel1, fax1, email, internet, object, OPENDATE, CLOSDATE, APPNMONEY2, APPNMONEY1, PROJCOST, publiss1, TOT_EQTY, ISSUEPRICE, ALOTMONEY1, ALOTMONEY2, MULTIPLES, MIN_APPLN }) => (
                                        <>
                                          
                                            <div className="table-responsive">
                                                <table className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th className="" colSpan={2} >Issue</th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th className="bdrright"></th>
                                                            <th className='text-right'>Money Payable On</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    </tbody>

                                                </table>
                                            </div>
                                            <div className="table-responsive">
                                                <table className='table'>
                                                    <thead>
                                                        <tr>

                                                            <th className="bdrright text-left">Opens On</th>
                                                            <th className="bdrright text-right">Closes On</th>
                                                            <th className="bdrright text-right">Application</th>
                                                            <th className="text-right">Allotment</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="bdrright text-left">{(OPENDATE != null) ? (format(parseISO(OPENDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                            <td className="bdrright text-right">{(CLOSDATE != null) ? (format(parseISO(CLOSDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                            <td className="bdrright text-right">Rs.{(APPNMONEY1 != null) ? APPNMONEY1.toFixed(2) : 0}-{(APPNMONEY2 != null) ? APPNMONEY2.toFixed(2) : 0} </td>
                                                            <td className="text-right">Rs.{(ALOTMONEY1 != null) ? ALOTMONEY1.toFixed(2) : 0}-{(ALOTMONEY2 != null) ? ALOTMONEY2.toFixed(2) : 0} </td>

                                                        </tr>
                                                        <tr>
                                                            <td className="text-left" colSpan="4">Minimum Application for shares in Nos : {MIN_APPLN}  Further Multiples of : {MULTIPLES}</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row table-responsive">
                                                <div className="column">

                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className="bdrright text-left"></th>
                                                                <th className="bdrright text-right">(Rs Cr)</th>

                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr>
                                                                <td className="bdrright text-left">Project Cost</td>
                                                                <td className="bdrright text-right">{(PROJCOST != null) ? PROJCOST.toFixed(2) : 0} </td>

                                                            </tr>
                                                            <tr>
                                                                <td className="bdrright text-left">Project Financed through Current Offer</td>
                                                                <td className="bdrright text-right">{(publiss1 != null) ? publiss1.toFixed(2) : 0} </td>

                                                            </tr>
                                                            <tr>
                                                                <td className="bdrright text-left">Post Issue Equity Share Capital</td>
                                                                <td className="bdrright text-right">{(TOT_EQTY != null) ? TOT_EQTY.toFixed(2) : 0} </td>

                                                            </tr>
                                                            <tr>
                                                                <td className="bdrright text-left">Issue Price</td>
                                                                <td className="bdrright text-right">Rs.{(ISSUEPRICE != null) ? ISSUEPRICE.toFixed(2) : 0} </td>

                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>
                                                <div className="column">
                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className='text-center'>Lead Managers to the Issue</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Datasix && Datasix.map(
                                                                ({ LEADMGR }) => (

                                                                    <tr>
                                                                        <td className="text-center">{LEADMGR}</td>

                                                                    </tr>
                                                                ))}

                                                        </tbody >
                                                    </table>
                                                </div>
                                            </div>

                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-left'>Projects</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Datatwo && Datatwo.map(
                                                        ({ project }) => (
                                                            <tr>
                                                                <td className='text-left'>{project}</td>

                                                            </tr>
                                                        ))}
                                                </tbody >


                                            </table>
                                            <div className="rown table-responsive">

                                                <div className="columnn">
                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className="bdrright text-left">Promoted By</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {Datathree && Datathree.map(
                                                                ({ promname }) => (

                                                                    <tr>
                                                                        <td className='bdrright text-left'>{promname}</td>
                                                                    </tr>
                                                                ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="columnn">
                                                    <table className='table'>
                                                        <thead>
                                                            <th className="bdrright text-center">Listing At</th>

                                                        </thead>
                                                        <tbody>
                                                            {Datafour && Datafour.map(
                                                                ({ LISTING }) => (
                                                                    <tr>

                                                                        <td className='bdrright text-center'>{LISTING}</td>

                                                                    </tr>
                                                                ))}

                                                        </tbody >


                                                    </table>
                                                </div>
                                                <div className="columnn">
                                                    <table className='table'>
                                                        <thead>

                                                            <th className='text-center'>Registrar to the Issue</th>

                                                        </thead>
                                                        <tbody>
                                                            {Datafive && Datafive.map(
                                                                ({ reg_name }) => (

                                                                    <tr>
                                                                        <td className='text-center'>{reg_name}</td>
                                                                    </tr>
                                                                ))}

                                                        </tbody >


                                                    </table>
                                                </div>
                                            </div>
                                            {/*  */}
                                              <div className=" table-responsive">
                                                <table className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>{lname}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="GridDataL">
                                                                <p>Registered Office : {regadd1},{regadd2},{regdist}-{regpin},{regstate},India.</p>
                                                                <p>Phone : {tel1} Fax :{fax1}</p>
                                                                <p>Email : {email}</p>
                                                                <p>Website : {internet}</p><br />

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{object}</td>
                                                        </tr>
                                                    </tbody>

                                                </table>
                                            </div>


                                        </>
                                    ))}
                            </div >

                        </section>
                    </Col>
                </Row>
            </Container >

        </>
    );
}

export default IPOSynopsis;